import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react'
import Results, { ResultItem } from '../Symbols/Results';

const ResultNumber = styled('span')`
	font-style: italic;
	text-align: right;
`;

const Total = css`
	font-size: 18px;
	font-weight: bold;
`;

export default function StyledResult({ bmr }) {
	return (
		<Results data-cy="result">
			{[{ name: 'Denní kalorická spotřeba:', kcal: bmr.kcal, kj: bmr.kj, highlighted: true }].map(
				({ name, kcal, kj, highlighted }) => {
					return (
						<ResultItem key={name} name={name} css={highlighted ? Total : null}>
							<ResultNumber>
								{kcal}&nbsp;kcal ({kj}&nbsp;KJ)
							</ResultNumber>
						</ResultItem>
					);
				},
			)}
		</Results>
	);
}
